/**
 * Represents customer role levels in ascending order of authorization.
 * Higher enum values indicate greater permissions and importance.
 */
export enum CustomerRole {
  /**
   * Default role for unauthorized/unrecognized user roles
   */
  UNKNOWN = 'unknown',
  /**
   * Users of a company/customer with access to non-sensitive pages
   */
  USER = 'user',
  /**
   * Users of a company/customer with access the planner page and other sensitive pages
   */
  PLANNER = 'planner',
  /**
   * Owners of a company/customer, with wide-access to almost every page
   */
  OWNER = 'owner',
  /**
   * Maintainers of the platform; accounts with elevated permissions
   */
  SERVICE = 'service',
}
